import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher';
import { useLanguage, t } from '../../utils/i18n';
import { motion, AnimatePresence } from 'framer-motion';
import { glassStyles } from '../../utils/glassStyles';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navLinks = [
    { to: "/", label: t('nav.home', language.code) },
    { to: "/catalog", label: t('nav.catalog', language.code) },
    { to: "/store", label: t('nav.store', language.code) },
    { to: "/about", label: t('nav.about', language.code) },
    { to: "/contact", label: t('nav.contact', language.code) },
  ];

  const noBlurStyle = {
    backgroundColor: 'rgba(0, 32, 15, 0.02)',
    borderColor: 'rgba(255, 255, 255, 0.5)'
  };

  return (
    <nav className="sticky top-0 z-50">
      <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: 'url("/assets/woodbgr3.jpg")' }}
      />
      <div className="absolute inset-0 bg-black/40 z-0" />

      <div className="relative z-10" style={noBlurStyle}>
        <div className="container-custom py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex items-center">
              <img src="/assets/logo.png" alt="Akasha Concept Store" className="h-16" />
            </Link>

            <div className="hidden md:flex items-center space-x-4">
              {navLinks.map((link) => (
                <motion.div
                  key={link.to}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Link
                    to={link.to}
                    className="text-white px-4 py-2 rounded-full transition-all duration-300 block hover:bg-white/10"
                    style={glassStyles.button}
                  >
                    {link.label}
                  </Link>
                </motion.div>
              ))}
              <LanguageSwitcher />
            </div>

            <div className="md:hidden flex items-center">
              <LanguageSwitcher />
              <motion.button
                onClick={toggleMenu}
                className="text-white focus:outline-none ml-4 p-2 rounded-full"
                style={glassStyles.button}
                whileHover={{ scale: 1.05, backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
                whileTap={{ scale: 0.95 }}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                )}
              </motion.button>
            </div>
          </div>

          <AnimatePresence>
            {isMenuOpen && (
              <motion.div 
                className="md:hidden mt-4 pb-4 rounded-[2rem] p-4"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                style={glassStyles.static}
              >
                <div className="flex flex-col space-y-2">
                  {navLinks.map((link) => (
                    <motion.div
                      key={link.to}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <Link
                        key={link.to}
                        to={link.to}
                        className="text-white px-4 py-2 rounded-full transition-all duration-300 block w-full text-center hover:bg-white/10"
                        style={glassStyles.button}
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {link.label}
                      </Link>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
